// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2ugqz","bigColWidth":"Table_bigColWidth__1mR6k","biggerColWidth":"Table_biggerColWidth__3AR6l","row":"Table_row__39hIg","col":"Table_col__2Bs0m"};